import { filterBillingData } from 'reactApp/api/billing/data/BillingDataAPICall.filters';
import { BillingDataCoreApi } from 'reactApp/api/billing/data/BillingDataAPICall.makeRequest';
import { BILLING_DATA_SSR, IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';
import {
    billingDataAllFallbackEnabled,
    billingDataFromSsrEnabled,
    billingDataOptimizationEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';

import { type BillingDataPeriods, BILLING_DATA_ALL_PERIOD } from './BillingDataAPICall.types';

const callPeriodicApi = async (period?: BillingDataPeriods, fromSsr?: boolean) => {
    if (billingDataFromSsrEnabled && BILLING_DATA_SSR && !IS_PUBLIC && fromSsr) {
        return BILLING_DATA_SSR;
    }
    return (await BillingDataCoreApi.makeRequest({ period: billingDataAllFallbackEnabled ? period : undefined })).data;
};

const callApi = async (period?: BillingDataPeriods, fromSsr = true) => {
    if (period === BILLING_DATA_ALL_PERIOD) {
        return callPeriodicApi(period, fromSsr);
    }
    return (await BillingDataCoreApi.makeRequest({ period })).data;
};

const billingDataCache: Record<BillingDataPeriods, ReturnType<typeof callApi> | null> = {
    current: null,
    past: null,
    future: null,
    [BILLING_DATA_ALL_PERIOD]: null,
};

const createBillingDataRequest =
    (fromCache: boolean, fromSsr = true) =>
    (period: BillingDataPeriods) => {
        // TODO:  выпилить блок с if после полной раскатки ssr https://jira.vk.team/browse/CLOUDWEB-18818
        if (billingDataOptimizationEnabled) {
            if (!fromCache || !billingDataCache[period]) {
                billingDataCache[period] = callApi(period, fromSsr);
            }
            return billingDataCache[period] as ReturnType<typeof callApi>;
        }
        return callApi(period, fromSsr);
    };

/** @description Только для тестов */
export const clearBillingDataCacheForTests = () => {
    billingDataCache.current = null;
    billingDataCache.past = null;
    billingDataCache.future = null;
    billingDataCache[BILLING_DATA_ALL_PERIOD] = null;
};

export const BillingDataAPI = {
    current: (fromCache: boolean, fromSsr?: boolean) => filterBillingData(createBillingDataRequest(fromCache, fromSsr), 'current'),
    past: (fromSsr?: boolean) => filterBillingData(createBillingDataRequest(true, fromSsr), 'past'),
    future: (fromSsr?: boolean) => filterBillingData(createBillingDataRequest(true, fromSsr), 'future'),
} as const;
